module.exports = __webpack_public_path__ + "static/img/akum_600_240.6326899.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_240.svg
// module id = bHF4
// module chunks = 1